export default "__VITE_ASSET__041c4c3f__"